module.exports = __webpack_public_path__ + "media/nature-doc.f480e400.mp4";